import React, {Component} from 'react'
import styled from 'styled-components'
import ErrorMessage from '../errorMessage/index'
import Group from '../group/index'
import classNames from 'classnames'

const InputStyled = styled.input`
    font-size:${props => props.fontSize ? `${props.fontSize}` : '1rem'};
    padding:${props => props.padding ? `${props.padding}` : '.3rem'};
    width:${props => props.width ? `${props.width}` : '100%'};
    margin:${props => props.margin ? `${props.margin}` : '0 0 1rem 0'};`,
    initialState = {
        errorMessage: "",
        value: ""
    }

class Input extends Component {
    constructor(props) {
        super(props)
        this.state = initialState
        this.validate = this.validate.bind(this)
        this.cleanInput = this.cleanInput.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    cleanInput() {
        this.setState(initialState)
    }

    handleChange(e) {
        this.setState({value: e.target.value})
    }

    validate() {
        const value = this.state.value,
            name = this.props.name

        if (this.props.isrequired && value.trim() === '') {
            this.setState({error: 'Campo obrigatório'})
            this.props.onChange(name, value, true)
            return false
        }

        const cepRegex = /^[0-9]{5}-[0-9]{3}$|^[0-9]{8}$/
        if (this.props.type === 'cep' && !cepRegex.test(value)) {
            this.setState({error: 'CEP inválido'})
            this.props.onChange(name, value, true)
            return false

        }

        this.props.onChange(name, value, false)
        this.setState({error: ''})
        return true
    }

    render() {
        const {error} = this.state
        const {icon, width, ...props} = this.props
        return (
            <Group width={width} className={classNames({
                icon
            })}>
                <InputStyled
                    {...props}
                    error={this.state.error}
                    onChange={this.handleChange}
                    value={this.state.value}/>
                {icon}
                {error && <ErrorMessage>{error}</ErrorMessage>}
            </Group>
        )
    }
}

export default Input